import styled from 'styled-components';
import { priceToString } from '../../util/utils';

interface StyledDivInterface {
  fontSize: string;
}

const StyledDiv = styled.div<StyledDivInterface>`
  table {
    font-size: ${(props: any) => props.fontSize || '10px'};
    /* table-layout: fixed; */
    width: 100%;
    /* border-collapse: collapse; */
    page-break-after: always;
  }

  table thead > tr > td {
    border: 1px solid;
    text-align: center;
    padding: 1px 1px;
  }

  table tbody > tr > td {
    border: 1px solid;
    padding: 1px 1px;
  }

  /* .cost-accounting-table table tbody > tr > td:nth-last-child(2) {
    text-align: left;
  } */

  table tbody > tr > td:nth-last-child(3) {
    text-align: right;
  }
`;

interface CostAccountingTableComponent2Props {
  projectName: string;
  metaData: any;
  costAccountingTableObj: any;
  tableFontSize?: string;
}

function CostAccountingTableComponent2({
  projectName,
  metaData,
  costAccountingTableObj,
  tableFontSize,
}: CostAccountingTableComponent2Props) {
  return (
    <StyledDiv fontSize={`${tableFontSize ? tableFontSize : '10px'}`}>
      <div style={{ textAlign: 'center' }}>
        <span style={{ textDecoration: 'underline', fontSize: '14px' }}>
          원가계산서
        </span>
      </div>
      <div style={{ textAlign: 'left' }}>
        <span>공사명: {projectName}</span>
      </div>
      {costAccountingTableObj && (
        <div className="cost-accounting-table">
          <table>
            <thead>
              <tr>
                <td colSpan={3}>비목</td>
                <td>하도급내역금액</td>
                <td>구성비</td>
                <td>비고</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={21} width="2%" style={{ textAlign: 'center' }}>
                  순공사원가
                </td>
                <td rowSpan={4} width="2%" style={{ textAlign: 'center' }}>
                  재료비
                </td>
                <td width="20%" style={{ textAlign: 'center' }}>
                  직접재료비
                </td>
                <td width="15%">
                  {priceToString(costAccountingTableObj.directMaterialCost)}
                </td>
                <td width="40%"></td>
                <td width="20%"></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>간접재료비</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>작업설, 부산물</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>[ 소 계 ]</td>
                <td>
                  {priceToString(costAccountingTableObj.materialCostTotal)}
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td rowSpan={3} style={{ textAlign: 'center' }}>
                  노무비
                </td>
                <td style={{ textAlign: 'center' }}>직접노무비</td>
                <td>{priceToString(costAccountingTableObj.directLaborCost)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>간접노무비</td>
                <td>{priceToString(costAccountingTableObj.value0)}</td>
                <td>직접노무비 * {metaData.costAccountingSheetRate0}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>[ 소 계 ]</td>
                <td>{priceToString(costAccountingTableObj.laborCostTotal)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td rowSpan={14} style={{ textAlign: 'center' }}>
                  경비
                </td>
                <td style={{ textAlign: 'center' }}>운반비</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>기계경비</td>
                <td>{priceToString(costAccountingTableObj.directExpense)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>산재보험료</td>
                <td>{priceToString(costAccountingTableObj.value1)}</td>
                <td>노무비 * {metaData.costAccountingSheetRate1}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>고용보험료</td>
                <td>{priceToString(costAccountingTableObj.value2)}</td>
                <td>노무비 * {metaData.costAccountingSheetRate2}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>국민건강보험료</td>
                <td>{priceToString(costAccountingTableObj.value3)}</td>
                <td>직접노무비 * {metaData.costAccountingSheetRate3}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>국민연금보험료</td>
                <td>{priceToString(costAccountingTableObj.value4)}</td>
                <td>직접노무비 * {metaData.costAccountingSheetRate4}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>노인장기요양보험료</td>
                <td>{priceToString(costAccountingTableObj.value5)}</td>
                <td>건강보험료 * {metaData.costAccountingSheetRate5}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>퇴직공제부금비</td>
                <td>{priceToString(costAccountingTableObj.value6)}</td>
                <td>직접노무비 * {metaData.costAccountingSheetRate6}%</td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>산업안전보건관리비</td>
                <td>{priceToString(costAccountingTableObj.value7)}</td>
                <td>
                  (재료비 + 직접노무비) * {metaData.costAccountingSheetRate7}% +{' '}
                  {metaData.costAccountingSheetBasePrice7}
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>기타경비</td>
                <td>{priceToString(costAccountingTableObj.value8)}</td>
                <td>
                  (재료비 + 노무비) * {metaData.costAccountingSheetRate8}%
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>환경보전비</td>
                <td>{priceToString(costAccountingTableObj.value9)}</td>
                <td>
                  (재료비 + 직접노무비 + 기계경비) *{' '}
                  {metaData.costAccountingSheetRate9}%
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>
                  건설하도급대금지급보증서발급수수료
                </td>
                <td>{priceToString(costAccountingTableObj.value10)}</td>
                <td>
                  (재료비 + 직접노무비 + 기계경비) *{' '}
                  {metaData.costAccountingSheetRate10}%
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>
                  건설기계대여금지급보증서발급수수료
                </td>
                <td>{priceToString(costAccountingTableObj.value11)}</td>
                <td>
                  (재료비 + 직접노무비 + 기계경비) *{' '}
                  {metaData.costAccountingSheetRate11}%
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center' }}>[ 소 계 ]</td>
                <td>{priceToString(costAccountingTableObj.expenseTotal)}</td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  계
                </td>
                <td>{priceToString(costAccountingTableObj.subTotal)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  일반관리비
                </td>
                <td>
                  {priceToString(costAccountingTableObj.administrativExpense)}
                </td>
                <td>계 * {metaData.costAccountingSheetRate12}%</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  이윤
                </td>
                <td>{priceToString(costAccountingTableObj.profit)}</td>
                <td>
                  (노무비 + 경비 + 일반관리비) *{' '}
                  {metaData.costAccountingSheetRate13}%
                </td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={3}>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  공급가액
                </td>
                <td>{priceToString(costAccountingTableObj.supplyPrice)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  부가가치세
                </td>
                <td>{priceToString(costAccountingTableObj.VAT)}</td>
                <td>공급가액의 {metaData.costAccountingSheetRate14}%</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  도급액
                </td>
                <td>{priceToString(costAccountingTableObj.contractPrice)}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  관급자재비
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={3}>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={3} style={{ textAlign: 'center' }}>
                  총공사비
                </td>
                <td>{priceToString(costAccountingTableObj.totalPrice)}</td>
                <td></td>
                <td></td>
              </tr>
              {/* <tr>
                <td colSpan={3}>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
              </tr> */}
            </tbody>
          </table>
        </div>
      )}
    </StyledDiv>
  );
}

export default CostAccountingTableComponent2;
